import de from "./de";

const deAT = {
  ...de,
  footer: {
    ...de.footer,
    copyright: "© {{year}} CRAFTFINDUS. Für Handwerksbetriebe in Österreich.",
  },
  home: {
    ...de.home,
    seoTitle: "Handwerksbetrieb finden in Österreich | Wien, Graz, Linz",
    seoDesc: "CRAFTFINDUS Österreich: Kostenlos den passenden Handwerksbetrieb finden. Elektriker, Installateur, Dachdecker in Wien, Graz, Linz und ganz Österreich.",
    heroDesc: "Beschreiben Sie Ihr Projekt. Wir finden 3 bis 5 passende Handwerksbetriebe in Österreich für Sie. Kostenlos, in unter 24 Stunden.",
    electricianDesc: "Elektroinstallation, Beleuchtung, Sicherungskästen, Smart Home – finden Sie einen Elektriker in Wien, Graz oder Linz.",
    plumbingDesc: "Bad-Renovierung, Heizungsaustausch, Rohrleitungen – professionelle Installateure in ganz Österreich.",
    roofingDesc: "Dachsanierung, Dachfenster, Dachstuhl – erfahrene Dachdecker in Ihrer Nähe in Österreich.",
    paintingDesc: "Fassadenanstrich, Tapezieren, Bodenbeläge – kreative Maler & Bodenleger in Österreich.",
    solarDesc: "Photovoltaik-Anlagen, Wärmepumpen, Klimaanlagen – nachhaltige Energielösungen in Österreich.",
    constructionDesc: "Trockenbau, Fliesenarbeiten, Komplettsanierung – Bauunternehmen in Wien, Graz, Linz und Salzburg.",
    faqC1A: "Ja, absolut! CRAFTFINDUS ist genau dafür gemacht. Beschreiben Sie einfach Ihr Projekt – wir finden das passende Gewerk und die richtigen Betriebe in Österreich für Sie. Komplett kostenlos.",
    faqC3A: "In der Regel melden sich qualifizierte Handwerksbetriebe aus Österreich innerhalb von 24 Stunden bei Ihnen. Bei dringenden Anfragen oft sogar schneller.",
    faqP1A: "Sie erhalten vorqualifizierte Projektanfragen aus Österreich, die zu Ihrem Gewerk und Ihrer Region passen. Maximal 3 bis 5 Betriebe pro Anfrage.",
  },
  auth: {
    ...de.auth,
    emailPlaceholder: "ihre@email.at",
  },
  inquiry: {
    ...de.inquiry,
    seoTitle: "Projektanfrage stellen – Handwerksbetriebe in Österreich finden",
    seoDesc: "Projektanfrage bei CRAFTFINDUS Österreich: Beschreiben Sie Ihr Projekt und wir finden bis zu 5 qualifizierte Handwerksbetriebe in Ihrer Region.",
    regionPlaceholder: "z.B. Wien, 1010",
    contactPhonePlaceholder: "+43 ...",
  },
  onboarding: {
    ...de.onboarding,
    regionPlaceholder: "z.B. Wien, 1010",
  },
};

export default deAT;
